export const cardData = [
  {
    title: "Safety Project",
    image:
      "https://static.igem.wiki/teams/4260/wiki/laboratory/laboratory-safety-project-5.jpg",
    description:
      "Throughout the year, the safety project team has been aiming to develop an antibiotic-free and eco-friendly selection marker in order to reduce antimicrobial resistance derived from experimental procedures. With this purpose, activities in the laboratory carried out for each of our three main objectives, are listed below 1) To accomplish a homogeneous distribution of isoeugenol culture mediums. 2) To evaluate the inhibitory effect of isoeugenol on the two most used Escherichia coli strains, DH5α and BL2. 3) To characterize the behavior of transformed cells with our genetic constructs Pp_22 and Nc_22.",
  },
  {
    title: "Parts",
    image:
      "https://static.igem.wiki/teams/4260/wiki/laboratory/laboratory-parts-1.jpg",
    description:
      "Initiating the design of the constructs in silico, team TecCEM designed and built constructs mixing existing parts and adding new ones to the registry (please see more at registry). Three main sets of parts were created: the Biosensor Parts, the Degradation Parts, and the Safety Project Parts. Referring to the Human Estrogen Receptor Alpha, RecA inteins (biosensor), Laccase TV and Laccase 15A (degradation) obtaining methodology was carried out as shown in the picture. Laccase 15A was retrieved from IGEM Plates, thus differs in steps 1-3, steps 2-9 were applied to hER alpha and both Laccases meanwhile, steps 8 and 9 were not necessary for RecA. For the results, please refer to the Results section. ",
  },
  {
    title: "Notebook",
    image:
      "https://static.igem.wiki/teams/4260/wiki/laboratory/laboratory-notebook-2.jpeg",
    description:
      "Hereafter we present our notebook containing all the experimental procedures and protocols carried out by the team regarding all the áreas in which our project is divided: detection, degradation and safety project. ",
  },
  {
    title: "Safety Form",
    image:
      "https://static.igem.wiki/teams/4260/wiki/laboratory/laboratory-safety-forms-1.jpg",
    description: "",
    shortDescription: "",
  },
];
